import { MainColorsScreen, ColorShadesScreen } from './ColorContent'
import { ColorIntroScreen } from './ColorIntro'

export const COLOR_SCREENS_ORDER = [
  ColorIntroScreen,
  MainColorsScreen,
  ColorShadesScreen
]
